module.exports = new Promise((resolve, reject) => {
  if (window.CheckoutPanelModules) return resolve(window.CheckoutPanelModules)
  const url = (window.__PANEL_CONFIG__ || {}).CHECKOUT_FEDERATED_MODULES || "https://panel-checkout-mfe.conekta.com/remote.js"
  const script = document.createElement('script')
  script.src = url
  script.async = true
  script.onload = () => resolve(window.CheckoutPanelModules)
  script.onerror = () => reject(new Error('Loading script failed: ' + url))
  document.head.appendChild(script)
});